import React, { lazy, Suspense } from 'react';
import './App.css';
import {BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeModeProvider } from './context/ThemeModeContext';

//componenty niechronione
import MainPage from './components/Home/MainPage/MainPage';
import LoginPage from './components/LoginPage/LoginPage';
import RegisterPage from './components/Home/RegisterPage/RegisterPage';
import PageLoader from './components/PageLoader/PageLoader';
import { AuthProvider } from './context/AuthContext';
import DefaultLayout from './components/DefaultLayout';
import CustomizationAdvanced from './components/HomeLogged/CustomizationAdvanced/CustomizationAdvanced';
import AccountEmployee from './components/HomeLogged/Account/AccountEmployee';
import Demo from './components/Home/Demo/Demo';
import DataReceiver from './components/Home/DataReceiver/DataReceiver';
import CoToNekrolog from './components/Home/CoToNekrolog/CoToNekrolog';
import KlepsydraWzor from './components/Home/Guides/KlepsydraWzor';
import NapisyNaSzarfy from './components/Home/Guides/NapisyNaSzarfy';
import GuidesIndex from './components/Home/Guides/GuidesIndex';
import DrukowanieSzarf from './components/Home/Guides/DrukowanieSzarf';
import TabliczkiNagrobne from './components/Home/Guides/TabliczkiNagrobne';
import MarketingZakladu from './components/Home/Guides/MarketingZakladu';
import KwiatyNaCmentarz from './components/Home/Guides/KwiatyNaCmentarz';
import SprzedazZniczy from './components/Home/Guides/SprzedazZniczy';
import SubscriptionExpired from './components/SubscriptionExpired/SubscriptionExpired';
import ForgotPassword from './components/LoginForm/ForgotPassword';
import ResetPassword from './components/LoginForm/ResetPassword';
import NotFound from './components/NotFound/NotFound';
import CookieBanner from './components/CookieBanner/CookieBanner';


//komponenty chronione dla usera
const PersonForm = lazy(() => import('./components/HomeLogged/PersonForm/PersonForm'));
const Quotes = lazy(() => import('./components/HomeLogged/Quotes/Quotes'));
const Definitions = lazy(() => import('./components/HomeLogged/Definitions/Definitions'));
const MassPlaces = lazy(() => import('./components/HomeLogged/MassPlaces/MassPlaces'));
const FuneralPlaces = lazy(() => import('./components/HomeLogged/FuneralPlaces/FuneralPlaces'));
const FamilyMembers = lazy(() => import('./components/HomeLogged/FamilyMembers/FamilyMembers'));
const Account = lazy(() => import('./components/HomeLogged/Account/Account'));
const XMLGenerator = lazy(() => import('./components/HomeLogged/layouts/XMLGenerator/XMLGenerator'));
const Templates = lazy(() => import('./components/HomeLogged/Templates/Templates'));
const Sash = lazy(() => import('./components/HomeLogged/layouts/Sash/Sash'));
const Customization = lazy(() => import('./components/HomeLogged/Customization/Customization'));
const ConsentsGate = lazy(() => import('./components/ConsentsGate/ConsentsGate'));
const Subscription = lazy(() => import('./components/HomeLogged/Subscription/Subscription'));

// import AdminPanel from './components/AdminPanel/AdminPanel';
const AdminPanel = lazy(() => import('./components/AdminPanel/AdminPanel'));


export default function App() {
  return (
    <HelmetProvider>
    <ThemeModeProvider>
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<PageLoader />}>
          <Routes>
          <Route element={<DefaultLayout />}>
              <Route path="*" element={<NotFound />} />

              <Route path="/" element={<MainPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/co-to-nekrolog" element={<CoToNekrolog />} />
              <Route path="/poradniki" element={<GuidesIndex />} />
              <Route path="/klepsydra-wzor" element={<KlepsydraWzor />} />
              <Route path="/napisy-na-szarfy" element={<NapisyNaSzarfy />} />
              <Route path="/drukowanie-szarf-pogrzebowych" element={<DrukowanieSzarf />} />
              <Route path="/jak-zrobic-tabliczke-nagrobna" element={<TabliczkiNagrobne />} />
              <Route path="/marketing-zakladu-pogrzebowego" element={<MarketingZakladu />} />
              <Route path="/jakie-kwiaty-na-cmentarz" element={<KwiatyNaCmentarz />} />
              <Route path="/sprzedaz-zniczy-wszystkich-swietych" element={<SprzedazZniczy />} />
              <Route path="/subscription-expired" element={<SubscriptionExpired />} />
              <Route path="/receive-data" element={<DataReceiver />} />

              <Route path="/admin" element={<ProtectedRoute element = {AdminPanel} adminOnly = {true} />} />

              <Route path="/consents" element={<ProtectedRoute element = {ConsentsGate} allowWithoutConsent />} />

              <Route path="/personForm" element={<ProtectedRoute element = {PersonForm}/>} />
              <Route path="/quotes" element={<ProtectedRoute element = {Quotes} />}/>
              <Route path="/definitions" element={<ProtectedRoute element = {Definitions} />}/>
              <Route path="/massplaces" element={<ProtectedRoute element = {MassPlaces} />} />
              <Route path="/funeralplaces" element={<ProtectedRoute element = {FuneralPlaces} />} />
              <Route path="/familymembers" element={<ProtectedRoute element = {FamilyMembers} />} />
              <Route path="/account" element={<ProtectedRoute element = {Account} />} />
              <Route path="/accountemployee" element={<ProtectedRoute element = {AccountEmployee} />} />
              <Route path="/subscription" element={<ProtectedRoute element = {Subscription} allowWithoutSubscription />} />
              <Route path="/sash" element={<ProtectedRoute element = {Sash} />} />
              <Route path="/XMLGenerator" element={<ProtectedRoute element = {XMLGenerator} />} />
              <Route path="/templates" element={<ProtectedRoute element = {Templates} />} />
              <Route path="/customization" element={<ProtectedRoute element = {Customization} />} />
              <Route path="/advanced-customization" element={<ProtectedRoute element = {CustomizationAdvanced} />} />
            </Route>
          </Routes>
        </Suspense>
        <CookieBanner />
      </BrowserRouter>
    </AuthProvider>
    </ThemeModeProvider>
    </HelmetProvider>
  );
}
